
import type { UUID, ISODateTimeString } from '../common';

// FIX: Updated Enum values to match Python Backend (app/models.py)
export enum FilePurposeEnum {
  KnowledgeSource = 'knowledge_source',
  AgentInput = 'agent_input',
  UserAvatar = 'user_avatar',
  VoiceInput = 'voice_input',

  General = 'general',
  UserUpload = 'user_upload',
}

export interface UploadedFileResponse {
  id: UUID;
  filename: string;
  content_type?: string;
  size_bytes: number;
  purpose: FilePurposeEnum | string;
  created_at: ISODateTimeString;
  url?: string;

  // NEW
  tokens_estimated?: number | null;
}

export interface FileUploadPayload {
  file: File;
  purpose?: FilePurposeEnum;
}
